import { useSessionFeatureState } from '@hooks/storeHooks/useSessionState';
import { useEffect } from 'react';

interface useBallanceProps {
  onZeroBalance: () => void;
}

export const useBallance = ({ onZeroBalance }: useBallanceProps) => {
  const { secondsBalance, creditBalance } = useSessionFeatureState();

  useEffect(() => {
    if (secondsBalance === 0) {
      onZeroBalance();
    }
  }, [secondsBalance, onZeroBalance]);

  return {
    secondsBalance,
    creditBalance,
  };
};
